// extracted by mini-css-extract-plugin
module.exports = {"holder":"styles_holder__W0bZQ"};